import { render, staticRenderFns } from "./news.vue?vue&type=template&id=25512710&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style1 from "./news.vue?vue&type=style&index=1&id=25512710&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25512710",
  null
  
)

export default component.exports